import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = 1;

const tabIndexSlice = createSlice({
  initialState,
  name: "tabIndex",
  reducers: {
    setTabIndex: (state: number, action: PayloadAction<number>) => {
      return action.payload;
    },
  },
});

export const { setTabIndex } = tabIndexSlice.actions;

export default tabIndexSlice.reducer;
